// extracted by mini-css-extract-plugin
export default {"summary":"SummaryItem_summary__2C4P3","stackedContent":"SummaryItem_stackedContent__zURgQ","link":"SummaryItem_link__o6+8B","disabledLink":"SummaryItem_disabledLink__EsIls"};